import { Text } from '../../../base/Text';
import { TooltipWrapper } from '../../../base/TooltipWrapper';
import { colorPalettes as colorPalette } from '../../../../context/theme';
import { SPACES } from '../../../../constants/sizes';
import { Tooltip, styled } from '@mui/material';

const StyledLastLoggedInWith = styled(Tooltip)`
  &:hover {
    cursor: pointer;
  }
`;

export const StyledText = styled(Text)`
  padding-left: 0.5rem;
`;

export const StyledTooltipWrapper = styled(TooltipWrapper)`
  padding: ${SPACES['x-small']};
`;

export const StyledCheckedProvider = styled.img`
  position: absolute;
  right: -0.2rem;
  bottom: 2rem;
  border: 1px solid
    ${({ theme }) =>
      colorPalette[theme.palette.mode].components.ProviderBoxesView
        .CheckedProvider.border.color};
  border-radius: 50%;
  width: 0.7rem;
  height: 0.7rem;
  background-color: ${({ theme }) =>
    colorPalette[theme.palette.mode].components.ProviderBoxesView
      .CheckedProvider.backgroundColor};
  padding: 0.4615rem;
`;

export default StyledLastLoggedInWith;
